import fetchJson from './fetch-json';

const isServer = typeof window === 'undefined';

let CMS_PROXY_URL = '/cms';

if (isServer) {
  const isStaging = /staging/.test(process.env.CMS_API_BASE);

  CMS_PROXY_URL = 'https://urban.co/cms';

  if (__DEV__) {
    // Change to http://localhost:3000/cms if running the cms locally
    CMS_PROXY_URL = 'https://staging.urban.co/cms';
  } else if (isStaging) {
    CMS_PROXY_URL = 'https://staging.urban.co/cms';
  }
}

function performRequest(ctx, url, options = {}) {
  let requestUrl = url;
  if (requestUrl[0] !== '/') {
    requestUrl = `/${url}`;
  }

  const opts = {
    ...options,
    headers: {
      ...options.headers,
    },
  };

  return fetchJson(`${CMS_PROXY_URL}${requestUrl}`, opts);
}

export class CMSSDK {
  constructor(ctx) {
    this.ctx = ctx;
  }

  get(url, options) {
    return performRequest(this.ctx, url, {
      ...options,
      method: 'GET',
    });
  }
}

export default function createCmsSdkInstance(ctx) {
  return new CMSSDK(ctx);
}



// WEBPACK FOOTER //
// ./spa/cms-sdk.jsx